import React from "react";
import { Box, Chip, FormControl, InputLabel, MenuItem, OutlinedInput, Select } from "@mui/material";

type Opt = { id: number; name: string };

/** Multi-select of groups by id, rendered as chips. */
export default function GroupPicker({
  value, onChange, options, label = "Groups", disabled,
}: {
  value: number[];
  onChange: (v: number[]) => void;
  options: Opt[];
  label?: string;
  disabled?: boolean;
}) {
  const nameOf = (id: number) => options.find((o) => o.id === id)?.name ?? `#${id}`;
  return (
    <FormControl fullWidth size="small" disabled={disabled}>
      <InputLabel>{label}</InputLabel>
      <Select
        multiple
        value={value}
        input={<OutlinedInput label={label} />}
        onChange={(e) => {
          const v = e.target.value;
          onChange(typeof v === "string" ? v.split(",").map(Number) : (v as number[]));
        }}
        renderValue={(sel) => (
          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
            {(sel as number[]).map((id) => (
              <Chip key={id} size="small" label={nameOf(id)} />
            ))}
          </Box>
        )}
      >
        {options.length === 0 && <MenuItem disabled value={-1}>No groups available</MenuItem>}
        {options.map((o) => (
          <MenuItem key={o.id} value={o.id}>{o.name}</MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
